export enum WorkitemTypeEnum {
    EMAIL ="EMAIL" ,
    IVR ="IVR",
    CHAT = "CHAT",
    MANUAL = "MANUAL",
    WHATSAPP = "WHATSAPP"
}
